module.exports = __webpack_public_path__ + "static/img/doctor.m.ca1f277.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/doctor.m.png
// module id = 678
// module chunks = 382